/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-fat milk is cheap and works for most antibodies; BSA is preferred for phospho-specific antibodies because milk contains phosphoproteins.`)
};

const es_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La leche desnatada es barata y funciona para la mayoría de anticuerpos; el BSA es preferible para anticuerpos fosfoespecíficos porque la leche contiene fosfoproteínas.`)
};

const de_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fettfreie Milch ist günstig und für die meisten Antikörper geeignet; bei phosphospezifischen Antikörpern wird BSA bevorzugt, da Milch Phosphoproteine enthält.`)
};

const nl_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magere melk is goedkoop en werkt voor de meeste antilichamen; BSA verdient de voorkeur voor fosfospecifieke antilichamen omdat melk fosfoproteïnen bevat.`)
};

const fr_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le lait écrémé est économique et convient à la plupart des anticorps ; la BSA est préférée pour les anticorps phospho-spécifiques car le lait contient des phosphoprotéines.`)
};

const it_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il latte scremato è economico e funziona per la maggior parte degli anticorpi; il BSA è preferibile per gli anticorpi fosfo-specifici perché il latte contiene fosfoproteine.`)
};

const pt_br2_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O leite desnatado é barato e funciona para a maioria dos anticorpos; o BSA é preferido para anticorpos fosfo-específicos porque o leite contém fosfoproteínas.`)
};

const pt_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O leite em pó magro é económico e funciona para a maioria dos anticorpos; o BSA é preferido para anticorpos fosfo-específicos porque o leite contém fosfoproteínas.`)
};

const ja_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無脂肪ミルクは安価でほとんどの抗体に適していますが、ミルクにはリン酸化タンパク質が含まれるため、リン酸化特異的抗体にはBSAが推奨されます。`)
};

const zh_buf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脱脂奶价格低廉，适用于大多数抗体；BSA 更适合磷酸化特异性抗体，因为脱脂奶中含有磷蛋白。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_a3", locale)
	if (locale === "en") return en_buf_faq_a3(inputs)
	if (locale === "es") return es_buf_faq_a3(inputs)
	if (locale === "de") return de_buf_faq_a3(inputs)
	if (locale === "nl") return nl_buf_faq_a3(inputs)
	if (locale === "fr") return fr_buf_faq_a3(inputs)
	if (locale === "it") return it_buf_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_a3(inputs)
	if (locale === "pt") return pt_buf_faq_a3(inputs)
	if (locale === "ja") return ja_buf_faq_a3(inputs)
	return zh_buf_faq_a3(inputs)
};